import * as React from 'react';
import { memo } from 'react';

const SvgPlayCircleV2 = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.25 7a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z", stroke: "currentColor" }),
    React.createElement("path", { d: "M8.75 7 6.125 5.25v3.5L8.75 7Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgPlayCircleV2);

export { Memo as default };
